const plans = [
  {
    model: 'Monthly',
    when: 'Start Compound on one product line and evaluate the method under real delivery pressure.',
    how: 'Full subscription — living skills, support, training, and enablement. Billed each month.',
    price: 'USD 2,000',
    unit: 'per month',
  },
  {
    model: 'Annual',
    when: 'Commit for a year of method evolution across your engineering organization.',
    how: 'Same full subscription. Two months equivalent included versus paying month to month.',
    price: 'USD 20,000',
    unit: 'per year',
  },
]

const included = [
  {
    label: 'Living skills',
    body: 'Continuously improved and optimized skill packs — tracking new models, tools, and approaches — plus breaking-change notes. Built for precise search and lower token spend as the industry moves.',
  },
  {
    label: 'Priority support',
    body: 'Direct channel to the Compound team for install issues, method questions, and unblockers when a traverse stalls.',
  },
  {
    label: 'Staff training',
    body: 'Enablement for your engineers and product leads — how to run analysis, specs, delivery waves, and review discipline inside Cursor.',
  },
  {
    label: 'Index onboarding',
    body: 'Guided setup of graph indexes, vector RAG, and semantic search on your repositories so large codebases become searchable from day one.',
  },
  {
    label: 'Office hours',
    body: 'Scheduled working sessions with Compound specialists to tune workflows, review a live wave, and tighten institutional memory.',
  },
  {
    label: 'Stack alignment',
    body: 'Help fitting Compound to your languages, CI, staging, and review culture — without turning the subscription into a full delivery engagement.',
  },
]

export function CompoundModels() {
  return (
    <section id="models" className="bg-sheet">
      <div className="mx-auto max-w-[100rem] px-6 py-12 lg:px-8 lg:py-16">
        <div className="mb-6 flex flex-col gap-2 border-b-2 border-ink pb-4 sm:flex-row sm:items-end sm:justify-between">
          <h2 className="section-title text-ink">Subscription plans</h2>
          <p className="text-sm leading-relaxed text-ink-muted sm:max-w-sm sm:text-right">
            Per organization. Skills, support, and training — not access alone.
          </p>
        </div>

        <div className="cell grid divide-y divide-rule lg:grid-cols-2 lg:divide-x lg:divide-y-0">
          {plans.map((row) => (
            <article key={row.model} className="flex flex-col px-5 py-6 sm:px-7 lg:py-8">
              <h3 className="entry-title text-ink">{row.model}</h3>

              <div className="mt-4 flex items-baseline gap-2 border-b border-rule-faint pb-5">
                <span
                  className="text-3xl font-bold text-ink"
                  style={{ fontStretch: '78%' }}
                >
                  {row.price}
                </span>
                <span className="cell-label text-ink-muted">{row.unit}</span>
              </div>

              <div className="mt-5 flex-1 space-y-5">
                <div>
                  <p className="cell-label text-ink-muted">When it fits</p>
                  <p className="mt-2 text-[0.9375rem] leading-relaxed text-ink-muted">
                    {row.when}
                  </p>
                </div>
                <div>
                  <p className="cell-label text-ink-muted">How it runs</p>
                  <p className="mt-2 text-[0.9375rem] leading-relaxed text-ink-muted">
                    {row.how}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 cell divide-y divide-rule">
          <div className="border-b-2 border-ink px-5 py-4 sm:px-7">
            <h3 className="entry-title text-ink">Included in every plan</h3>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-ink-muted">
              The subscription is an operating partnership around the method —
              not a private git invite with a price tag.
            </p>
          </div>

          <div className="hidden grid-cols-[12rem_1fr] gap-6 bg-sheet-edge/60 px-5 py-2.5 sm:px-7 lg:grid">
            <span className="cell-label text-ink-muted">Line</span>
            <span className="cell-label text-ink-muted">What you receive</span>
          </div>

          {included.map((row) => (
            <article
              key={row.label}
              className="grid gap-2 px-5 py-5 sm:px-7 lg:grid-cols-[12rem_1fr] lg:gap-6 lg:py-5"
            >
              <h4 className="entry-title text-ink" style={{ fontStretch: '84%' }}>
                {row.label}
              </h4>
              <p className="text-[0.9375rem] leading-relaxed text-ink-muted">
                {row.body}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
